import * as $ from 'jquery';
import { apiBaseUrlUser } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";

export default class HomeService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/home`;

    public RouteGetContacts = () => `${this.baseUrl}/getContacts`;
    public getContacts(): JQueryPromise<any> {
        return $.ajax(this.RouteGetContacts(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetBanners = () => `${this.baseUrl}/getBanners`;
    public getBanners(): JQueryPromise<any> {
        return $.ajax(this.RouteGetBanners(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}